<template>
  <div class="panel-body">
    <v-dialog
      v-if="this.selected != null && this.selected.length > 0"
      persistent
      v-model="dialog"
      max-width="1000px"
    >
      <jar
        ref="jarRef"
        eager
        :activeTab="this.jarTab"
        :jar="selected[0]"
        :user="user"
        @close-jar="dialog = false"
        @fundsadded-jar="fundsAdded"
      ></jar>
    </v-dialog>

    <template>
      <v-form>
        <v-container>
          <v-flex>
            <v-row>
              <v-col cols="6">
                <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-btn style="margin-top: 35px;" @click="jarDialog = true">New Jar</v-btn>
          </v-row>
          </v-flex>
          <v-row>
            <v-checkbox label="Active" v-model="activeItems" value="active" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Inactive" v-model="activeItems" value="inactive" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Hold" v-model="activeItems" value="hold" @change="staticFilter"></v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox label="Default" v-model="jarTypeItems" value="default" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Incentive" v-model="jarTypeItems" value="incentive" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Incentive Payment" v-model="jarTypeItems" value="incentive-payment" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Reward" v-model="jarTypeItems" value="reward" @change="staticFilter"></v-checkbox>
            <v-checkbox label="Charity" v-model="jarTypeItems" value="charity" @change="staticFilter"></v-checkbox>
            <v-checkbox v-if= "IsUs" label="Group Savings" v-model="jarTypeItems" value="Group Savings" @change="staticFilter"></v-checkbox>
          </v-row>
          <template>
              <div>
                <v-dialog v-model="jarDialog" max-width="500px" scrollable persistent>
                  <v-card>
                    <v-card-title class="headline">Add Jar</v-card-title>
                    <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="jarAddRequest.name" label="Name"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select v-model="jarAddRequest.categoryName" :items="dropdownOptions" label="Category"></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="jarAddRequest.goal" label="Goal ($)"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="jarAddRequest.typeId" label="JarTypeId" disabled></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" text @click="close()">Close</v-btn>
                      <v-btn color="primary" text v-if="jarAddRequest.name !== '' && jarAddRequest.name !== null" @click="addJar()">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </template>
        </v-container>
      </v-form>
      <v-card>
        <v-alert v-model="showAlert" :type="alertType" dismissible>
          {{alertMessage}}
        </v-alert>
      <v-data-table
          a
          :headers="headers"
          :items="filteredJars"
          :search="search"
          :loading="loadingJars"
          item-key="id"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
          <template v-slot:item.action="{ item }">
            <v-menu>
              <template v-slot:activator="{ on }">
                <!-- <v-btn dark icon>
                  <v-icon small @click="selectJar(item)">visibility</v-icon>
                </v-btn>-->
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="selectJar(item, 0)">
                  <v-list-item-title>View Details</v-list-item-title>
                </v-list-item>
                <v-list-item :disabled="item.status !== 'ACTIVE'" @click="selectJar(item, 2)">
                  <v-list-item-title>Add Funds</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.status === 'ACTIVE'" @click="holdJar(item)">
                  <v-list-item-title>Put on Hold</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.status === 'HOLD'" @click="reactivateJar(item)">
                  <v-list-item-title>Reactivate</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.status !== 'INACTIVE'" @click="cashoutJar(item, false)">
                  <v-list-item-title>Cashout & Continue</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.status !== 'INACTIVE'" @click="cashoutJar(item, true)">
                  <v-list-item-title>Cashout & Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template slot="no-data"></template>
  </div>
</template>

<script>
import jar from '@/components/Jar.vue'

let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    id: '',
    search: '',
    model: null,
    jarTab: 0,
    IsUs: false,
    dropdownOptions: [
      'Rainy Day Savings',
      'Rewards',
      'Refunds/Adjustments'
    ],
    rppItems: [
      10,
      25,
      50,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    jarRef: null,
    selected: [],
    errors: [],
    dialog: false,
    loadingJars: false,
    showAlert: false,
    alertMessage: '',
    alertType: 'success',
    headers: [
      { text: 'Jar ID', width: '10%', align: 'left', value: 'id' },
      { text: 'Child Jar ID', width: '10%', align: 'left', value: 'incentivePaymentJar.id' },
      { text: 'Name', width: '17%', value: 'name' },
      { text: 'Type', width: '13%', value: 'typeName' },
      { text: 'Category', width: '23%', value: 'categoryName' },
      { text: 'Saved', width: '10%', align: 'left', value: 'received' },
      {
        text: 'Goal',
        width: '10%',
        align: 'left',
        value: 'goal'
      },
      { text: 'Status', width: '10%', align: 'left', value: 'status' },
      // {
      //   text: 'Created',
      //   width: '15%',
      //   align: 'left',
      //   value: 'wishlist.createdDate'
      // },
      { text: '', width: '5%', value: 'action', sortable: false }
    ],
    newjar: null,
    jarAddRequest: {
      name: '',
      categoryName: '',
      goal: 1000.00,
      typeId: 1,
      userId: ''
    },
    defaultAddRequest: {
      name: '',
      categoryName: '',
      goal: 1000.00,
      typeId: 1,
      userId: ''
    },
    jarDialog: false,
    jars: [],
    filteredJars: [],
    activeRadios: 'all',
    typeRadios: 'default',
    activeItems: ['active', 'hold'],
    jarTypeItems: []
  }),
  components: {
    jar
  },
  created () {
    this.loadJars()
    this.isEnvironmentUS()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadJars()
      }
    }
  },
  methods: {
    async selectJar (a, tab) {
      this.jarTab = tab
      this.dialog = true
      this.selected = [a]
      if (this.$refs.jarRef) this.$refs.jarRef.model = tab
    },
    isEnvironmentUS () {
      if (JSON.parse(sessionStorage.getItem('selectedEnv'))['code'] === 'US') {
        this.IsUs = true
      }
    },
    async loadJars () {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        this.jars = []
        this.filteredJars = []
        return
      }
      this.loadingJars = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_JAR
      }/jars/user/${this.user.userId}?types=all&status=all`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (!getResponse || !getResponse.data) {
        this.jars = []
      } else {
        this.jars = getResponse.data
      }

      this.staticFilter()
      this.loadingJars = false
    },
    async addJar () {
      if (this.jarAddRequest.name !== '' && this.jarAddRequest.name !== null) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars`
      }

      this.jarAddRequest.name = this.jarAddRequest.name
      this.jarAddRequest.categoryName = this.jarAddRequest.categoryName
      this.jarAddRequest.goal = this.jarAddRequest.goal
      this.jarAddRequest.typeId = this.jarAddRequest.typeId
      this.jarAddRequest.userId = this.user.userId

      var response = await rh.default.post(endpoint, this.jarAddRequest, true).catch(e => {
        this.errors.push(e)
      })
      this.loadJars()
      this.jarDialog = false
      this.jarAddRequest = this.defaultAddRequest
    },
    getJarStatus () {},
    async holdJar (selectedJar) {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/deactivates/${selectedJar.id}`

      var getResponse = await rh.default.delete(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.loadJars()
    },
    async reactivateJar (selectedJar) {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/reactivate/${selectedJar.id}`

      var getResponse = await rh.default.delete(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.loadJars()
    },
    async cashoutJar (selectedJar, deleteJar) {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/cashout/${selectedJar.id}?delete=${deleteJar}`

      this.alertMessage = `Successfully cashed out ${selectedJar.received} from jar ${selectedJar.name}`
      this.alertType = 'success'
      var getResponse = await rh.default.delete(endpoint, true).catch(e => {
        this.alertMessage = `An error occured cashing out ${selectedJar.received} from jar ${selectedJar.name}`
        this.alertType = 'error'
        this.errors.push(e)
      })
      this.showAlert = true
      this.loadJars()
    },
    async addFunds (selectedJar) {
      alert('Working on it')
    },
    async fundsAdded () {
      this.loadJars()
    },
    close () {
      this.jarAddRequest = this.defaultAddRequest
      this.jarDialog = false
    },
    staticFilter () {
      this.filteredJars = this.jars

      if (this.activeItems.includes('active') || this.activeItems.includes('inactive') || this.activeItems.includes('hold')) {
        this.filteredJars = this.filteredJars.filter(i => {
          return ((this.activeItems.includes('active') && i.status === 'ACTIVE') ||
          (this.activeItems.includes('inactive') && i.status === 'INACTIVE') ||
          (this.activeItems.includes('hold') && i.status === 'HOLD'))
        })
      }

      if (this.jarTypeItems.includes('default') || this.jarTypeItems.includes('incentive') || this.jarTypeItems.includes('incentive-payment') || this.jarTypeItems.includes('reward') || this.jarTypeItems.includes('charity') || this.jarTypeItems.includes('Group Savings')) {
        this.filteredJars = this.filteredJars.filter(i => {
          return ((this.jarTypeItems.includes('default') && i.typeCode === 'default') ||
          (this.jarTypeItems.includes('incentive') && i.typeCode === 'incentive') ||
          (this.jarTypeItems.includes('incentive-payment') && i.typeCode === 'incentive-payment') ||
          (this.jarTypeItems.includes('reward') && i.typeCode === 'reward') ||
          (this.jarTypeItems.includes('charity') && i.typeCode === 'charity') ||
          (this.jarTypeItems.includes('Group Savings') && i.typeCode === 'group-saving'))
        })
      }
    }
  }
}
</script>
<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
v-btn {
  color: black;
}
</style>
